// extracted by mini-css-extract-plugin
export default {"mainContainer":"stats_section-module___mainContainer___a4ed78d3","statColumn":"stats_section-module___statColumn___c869d53e","label":"stats_section-module___label___be2da03b"};